import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Search from './Search';
import { Container } from '@mui/material';
import DashTheme from './DashTheme';
import AdminDashboard from './AdminDashboard';
import { GlobalStyles } from '@mui/material';

export default function Dashboard() {
  
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };


  // TODO remove, this demo shouldn't need to reset the theme.
  const defaultTheme = createTheme();

  return (
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyles
        styles={{
          '::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '::-webkit-scrollbar-track': {
            background: 'rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
          },
          '::-webkit-scrollbar-thumb': {
            background: 'linear-gradient(45deg,rgb(221, 226, 255), rgb(221, 226, 255))',
            borderRadius: '10px',
          },
          '::-webkit-scrollbar-thumb:hover': {
            background: 'linear-gradient(45deg,rgb(205, 211, 255), rgb(205, 211, 255))',
          },
          '*': {
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgb(221, 226, 255) rgba(0, 0, 0, 0.1)',
          },
        }}
      />
      <Box sx={{ display: 'flex' }}>
        <DashTheme />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          
            <AdminDashboard/>
        
        </Box>
      </Box>
    </ThemeProvider>
  );
}